// Zweck: Sitzungsfehler über API-Wrapper und Offline-Queue hinweg erkennen.
// Kontext: Fehlende Anmeldung darf weder Fotos löschen noch Retries verbrauchen.
// Stand: 2026-10-26
export function isSessionError(error: unknown): boolean {
  if (!error || typeof error !== 'object') return false;
  const failure = error as { status?: unknown; isAuthMissing?: unknown };
  return failure.status === 401 || failure.isAuthMissing === true;
}
